
<style scoped>
.disflex {
  display: flex;
}

.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.detail-row {
  display: flex;
  padding: 0 20px;
}

.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}

.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}

.detail-row .item .content {
  width: 500px;
  text-align: left;
}

.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}

.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}

/deep/ .el-upload-list {
  text-align: left;
  max-height: 150px;
  overflow-y: auto;
}
/deep/ .el-form-item{
  margin-bottom: 8px;
}
/deep/ .el-form-item__content{
  line-height: 35px;
}
</style>
<style >
.freelist .el-form-item__content {
  margin-left: 0 !important;
}

.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

.freelist .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.freelist .el-image {
  visibility: hidden;
}

.freelist .file1 .el-upload--picture-card {
  display: none;
}

.el-image-viewer__wrapper {
  z-index: 99999 !important;
}

.el-col-8 {
  display: flex;
}

.ipt-sty {
  flex: 1;
}
</style>
<template>
  <div class="content freelist" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- search start -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">公司名称</div>
          <el-select size="mini" clearable v-model="page.tenantGuid" placeholder="请选择公司名称" filterable class="ipt-sty"
            @change="getOrganisationList(page.tenantGuid)">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称</div>
          <el-select size="mini" clearable v-model="page.organisationGuid" placeholder="请选择部门名称" filterable
            class="ipt-sty">
            <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">支付日期</div>
          <el-date-picker clearable size="mini" v-model="timeLists" type="daterange" range-separator="至"
            start-placeholder="开始时间" class="ipt-sty" end-placeholder="结束时间">
          </el-date-picker>
        </el-col>
        <el-col :span="6" style="display:block" class="t-right">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">

        <el-col :span="6">
          <div class="search-area-div">核算月份</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="page.accountMonth" type="month" align="left" unlink-panels
            placeholder="请选择核算月份" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
            value-format="yyyyMM">
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="disflex">
          <div class="search-area-div" style="width:auto">人员/手机号</div>
          <el-input size="mini" v-model="page.nameOrPhone" class="ipt-sty" placeholder="请输入人员/手机号"></el-input>
        </el-col>

      </el-row>
    </div>
    <!-- search end -->

    <!-- table start -->
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" >
      <div class="button-area" style="margin-bottom: 0;">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addContract()">上传支付凭证</el-button>
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addContractMore()">批量上传支付凭证</el-button>
        <el-button size="mini" type="info" @click="showDownload = true">批量下载</el-button>
      </div>
      <el-table :data="tableData" :height="tableHeight" stripe border v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="accountMonth" width="70" label="核算月份" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.accountMonth }}</template>
        </el-table-column>
        <el-table-column prop="accountMonth" width="100" label="支付日期" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.paymentTime | getDate }}</template>
        </el-table-column>

        <el-table-column prop="tenantName" label="公司名称" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column prop="organisationName" label="部门名称" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>

        <el-table-column prop="staffName" width="130" label="人员姓名" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.staffName }}</template>
        </el-table-column>

        <el-table-column prop="staffPhone" width="130" label="人员手机号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.staffPhone || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" width="150" label="上传时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="250">
          <template slot-scope="scope">
            <a class="txt-color" @click="preview(scope.row.paymentAttach)">查看凭证 | </a>
            <a class="txt-color" v-if="scope.row.paymentAttach != '[]' && scope.row.paymentAttach != null"
              @click="down(scope.row)">下载凭证 | </a>
            <a class="txt-color" @click="editContract(scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- table end -->

    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- 单个上传 start -->
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="580px">
      <el-form label-width="80px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">核算月份</span>
          <el-date-picker class="ipt-sty fl" v-model="tax.accountMonth" type="month" placeholder="选择核算月份"
            value-format="yyyyMM">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">支付时间</span>
          <el-date-picker class="ipt-sty fl" v-model="tax.paymentTime" type="date" placeholder="选择支付时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择公司</span>
          <el-select v-model="tax.tenantGuid" placeholder="请选择公司" class="ipt-sty fl" filterable
            @change="getStaffList(tax.tenantGuid, true)">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择人员</span>
          <el-select v-model="tax.staffGuid" placeholder="请选择人员" class="ipt-sty fl" filterable
            @change="getStaffDetail(tax.staffGuid)">
            <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="tax.organisationName">
          <span slot="label" style="color: red">*</span>
          <span slot="label">人员信息</span>
          <span class="fl">{{ tax.mobileNo }} {{ tax.organisationName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom:0;">
          <span slot="label" style="color: red">*</span>
          <span slot="label">支付凭证</span>
          <el-upload action="#" name="image" class="fl" list-type="picture-card" :headers="token" :limit="1"
            accept=".jpg,.png,.jpeg" :on-exceed="handleExceed" :file-list="filePdfAttachListII"
            :on-remove="handlePdfRemoveII" :http-request="uploadPdfII">
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="color: #999; text-align: left;">
          说明：上传业务员的相关支付凭证截图
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" v-if="textTitle == '新增支付凭证'" @click="addReqVersion(1)">添加下一个</el-button>
        <el-button size="mini" type="info" v-if="textTitle == '新增支付凭证'" @click="addReqVersion(2)">确 定</el-button>

        <el-button size="mini" type="info" v-else @click="updateReqVersion">修 改</el-button>
      </span>
    </el-dialog>
    <!-- 单个上传 end -->
    <!-- 批量上传 start -->
    <el-dialog title="批量上传支付凭证" :visible.sync="dialogVisible1" width="580px">
      <el-form label-width="80px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">核算月份</span>
          <el-date-picker class="ipt-sty fl" v-model="tax1.accountMonth" type="month" placeholder="选择核算月份"
            value-format="yyyyMM">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">支付时间</span>
          <el-date-picker class="ipt-sty fl" v-model="tax1.paymentTime" type="date" placeholder="选择支付时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择公司</span>
          <el-select v-model="tax1.tenantGuid" filterable placeholder="请选择公司" class="ipt-sty fl">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">支付凭证</span>
          <el-upload class="fl upload-demo" drag action="#" :headers="token" accept=".jpg,.png,.jpeg"
            :on-remove="handleImgRemove" :http-request="uploadImg" show-file-list :file-list="filePdfAttachListIII"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </el-form-item>
        <div style="color: #999; text-align: left; margin-left: 80px; margin-bottom: 0px">
          说明：<br>1、选择本地电脑中的一个文件夹;<br>2、文件夹中存放每个业务员支付凭证的图片;<br>3、必须一人一张图，每张图片的命名规则如：张三_13100000001;
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button size="mini" type="info" @click="addReqVersionAll">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量上传 end -->
    <el-image-viewer width="100%" v-if="showViewer" :on-close="
      () => {
        showViewer = false;
      }
    " :url-list="srcLists" />
    <downloadZip v-if="showDownload" @close="showDownload = false;"></downloadZip>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import DownloadZip from './components/DownloadZip.vue';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    DownloadZip
  },
  data() {
    return {
      showDownload: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      showMore: false,
      giveStatueList: [
        { value: '0', label: '全部' },
        { value: '1', label: '已上传' },
        { value: '2', label: '未上传' },
      ],
      tax: { //单个上传支付凭证 请求参数
        tenantGuid: '',
        tenantName: '',
        accountMonth: '',
        pictContent: '',
        staffName: '',
        staffGuid: '',
        mobileNo: '',
        organisationGuid: '',
        organisationName: '',
        paymentTime: '',
      },
      tax1: { //批量上传支付凭证请求参数
        tenantGuid: '',
        tenantName: '',
        accountMonth: '',
        pictContent: '',
        paymentTime: '',
      },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        startDate: '',
        endDate: '',
        tenantGuid: '',//公司
        organisationGuid: '',//部门
        accountMonth: '',
        nameOrPhone: '',
        currentTenantGuid:localStorage.guid
      },
      staffList: [],
      tenantList: [],
      organisationList: [],
      errorInfoList: [],
      timeLists: '',
      srcLists: [],
      fullscreenLoading: false,
      textTitle: '新增支付凭证',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      startEndTime: '',
      payMoney: '',
      note: '',
      payFile: '',

      guid: '',
      tableLoading: false,
      tableData: [],
      right: 'right',
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      filePdfAttachList: [],
      filePdfAttachListII: [],
      filePdfAttachListIII: [],
      showViewer: false,
      taskList: [],
      taskGroup: [],
      currentCompanyGuid: ''
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    this.getTenantList();
    this.getList();

  },
  watch: {
  },
  methods: {
    //预览
    preview(srcList) {
      this.srcLists = [];
      srcList.forEach((item) => {
        this.srcLists.push(item.path);
      });
      this.$forceUpdate();
      this.showViewer = true;
    },
    //获取企业
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取组织
    getOrganisationList(tenantGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: tenantGuid
      };
      if (!tenantGuid) return;
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
          self.page.organisationGuid = '';
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取成员
    getStaffList(guid, flag) {
      let self = this;
      self.fullscreenLoading = true;
      this.api.get(
        `/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + guid
      ).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
          if (flag) {
            self.tax.staffGuid = '';
            self.tax.staffName = '';
            self.tax.organisationName = '';
            self.tax.organisationGuid = '';
            self.tax.mobileNo = '';
          }
          console.log(this.staffList)
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取成员详细信息
    getStaffDetail(guid) {
      let self = this;
      if (self.staffList != null && self.staffList.length > 0) {
        self.staffList.forEach((i) => {
          if (guid == i.guid) {
            self.tax.staffName = i.staffName;
            self.tax.organisationGuid = i.guid;
            self.tax.organisationName = i.organisationNames;
            self.tax.mobileNo = i.mobileNo;

          }
        })
      }
    },
    //清空搜索
    emptySearch() {
      this.timeLists = [];
      this.organisationList = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        startDate: '',
        endDate: '',
        tenantGuid: '',
        organisationGuid: '',
        accountMonth: '',
        nameOrPhone: '',
        currentTenantGuid:localStorage.guid
      };
      this.getList(true);
    },
    //新增
    addContract() {
      this.textTitle = '新增支付凭证';
      this.tax = {
        tenantGuid: '',
        accountMonth: '',
        pictContent: '',
        staffName: '',
        staffGuid: '',
        mobileNo: '',
        organisationGuid: '',
        organisationName: '',
      };
      this.staffList = [];
      this.filePdfAttachListII = [];
      this.dialogVisible = true;
    },
    //批量上传
    addContractMore() {
      this.tax1 = {
        tenantGuid: '',
        tenantName: '',
        accountMonth: '',
        paymentTime: '',
      };
      this.filePdfAttachListIII = [];
      this.dialogVisible1 = true;
    },
    //编辑
    editContract(detail) {
      this.textTitle = '编辑支付凭证';
      this.filePdfAttachListII = [];
      this.getStaffList(detail.tenantGuid);
      this.tax = {
        guid: detail.guid,
        tenantGuid: detail.tenantGuid,
        accountMonth: detail.accountMonth,
        staffName: detail.staffName,
        staffGuid: detail.staffGuid,
        mobileNo: detail.staffPhone,
        organisationGuid: detail.organisationGuid,
        organisationName: detail.organisationName,
        paymentTime: detail.paymentTime,
      };
      if (detail.paymentAttach != null && detail.paymentAttach.length > 0) {
        detail.paymentAttach.forEach((item) => {
          this.filePdfAttachListII.push({
            name: item.fileName,
            url: item.path,
          });
        });
      }
      this.dialogVisible = true;
    },
    //下载凭证
    down(detail) {
      let path = '';
      let name = '';
      if (detail.paymentAttach != null && detail.paymentAttach.length > 0) {
        detail.paymentAttach.forEach((item) => {
          path = item.path;
          name = item.fileName;
        });
        this.downloadIamge(path, name);
      }
    },
    //下载图片地址和图片名    
    downloadIamge(imgsrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    getList(flg) {
      var self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (self.timeLists != null && self.timeLists.length > 0) {
        self.page.startDate = self.$moment(self.timeLists[0]).format('YYYY-MM-DD');
        self.page.endDate = self.$moment(self.timeLists[1]).format('YYYY-MM-DD');
      } else {
        self.page.startDate = '';
        self.page.endDate = '';
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/paymentCertificate/pageQuery`, self.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除
    getDeleteData(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/paymentCertificate/del?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    //批量上传支付凭证
    addReqVersionAll() {
      var self = this;
      if (!this.tax1.accountMonth) {
        self.$message('请选择核算月份!');
        return;
      }
      if (!this.tax1.paymentTime) {
        self.$message('请选择支付时间!');
        return;
      }
      if (!this.tax1.tenantGuid) {
        self.$message('请选择公司!');
        return;
      }
      if (!this.filePdfAttachListIII.length) {
        self.$message.error('请上传支付凭证!');
        return;
      }
      let imgList = [];
      if (this.filePdfAttachListIII != null && this.filePdfAttachListIII.length > 0) {
        this.filePdfAttachListIII.forEach((i) => {
          let item = {
            fileName: i.name,
            path: i.url
          }
          imgList.push(item);
        })
      }
      console.log(imgList);
      var tenantList = this.tenantList;
      var tenantName;
      tenantList.forEach(item => {
        if (item.sendTenantGuid == self.tax1.tenantGuid) {
          tenantName = item.sendTenantName
        }
      })
      var req = {
        tenantGuid: self.tax1.tenantGuid,
        tenantName: tenantName,
        accountMonth: this.tax1.accountMonth,
        paymentTime: this.tax1.paymentTime,
        paymentAttach: imgList
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/paymentCertificate/addBatch`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

          if (res.data.data.errorInfo != null && res.data.data.errorInfo.length > 0) {
            let errorInfoList = res.data.data.errorInfo;
            this.$message.error(errorInfoList.join('、'));
          } else {
            self.dialogVisible1 = false;
            self.$message.success('新增成功');
            self.page.pageIndex = 1;
            self.getList(true);
          }

        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //上传单个支付凭证
    addReqVersion(type) {
      var self = this;
      if (!this.tax.accountMonth) {
        self.$message.error('请选择核算月份!');
        return;
      }
      if (!this.tax.paymentTime) {
        self.$message.error('请选择支付时间!');
        return;
      }
      if (!this.tax.tenantGuid) {
        self.$message.error('请选择公司!');
        return;
      }
      if (!this.tax.staffGuid) {
        self.$message.error('请选择人员!');
        return;
      }
      if (!this.filePdfAttachListII.length) {
        self.$message.error('请上传支付凭证!');
        return;
      }
      let imgList = [];
      if (this.filePdfAttachListII != null && this.filePdfAttachListII.length > 0) {
        let item = {
          fileName: this.filePdfAttachListII[0].name,
          path: this.filePdfAttachListII[0].url
        }
        imgList.push(item);
      }
      console.log(imgList);
      var tenantList = this.tenantList;
      var tenantName;
      tenantList.forEach(item => {
        if (item.sendTenantGuid == self.tax.tenantGuid) {
          tenantName = item.sendTenantName
        }
      })
      var req = {
        tenantGuid: self.tax.tenantGuid,
        tenantName: tenantName,
        accountMonth: this.tax.accountMonth,
        staffGuid: this.tax.staffGuid,
        staffName: this.tax.staffName,
        organisationGuid: this.tax.organisationGuid,
        organisationName: this.tax.organisationName,
        staffPhone: this.tax.mobileNo,
        paymentTime: this.tax.paymentTime,
        paymentAttach: imgList,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/paymentCertificate/add`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('新增成功');
          if (type == 1) {
            this.addContract();
          } else {
            self.dialogVisible = false;
            self.page.pageIndex = 1;
          }
          self.getList(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //更新单个支付凭证
    updateReqVersion() {
      var self = this;
      if (!this.tax.accountMonth) {
        self.$message.error('请选择核算月份!');
        return;
      }
      if (!this.tax.paymentTime) {
        self.$message.error('请选择支付时间!');
        return;
      }
      if (!this.tax.tenantGuid) {
        self.$message.error('请选择公司!');
        return;
      }
      if (!this.tax.staffGuid) {
        self.$message.error('请选择人员!');
        return;
      }
      if (!this.filePdfAttachListII.length) {
        self.$message.error('请上传支付凭证!');
        return;
      }
      let imgList = [];
      if (this.filePdfAttachListII != null && this.filePdfAttachListII.length > 0) {
        let item = {
          fileName: this.filePdfAttachListII[0].name,
          path: this.filePdfAttachListII[0].url
        }
        imgList.push(item);
      }
      var tenantList = this.tenantList;
      var tenantName;
      tenantList.forEach(item => {
        if (item.sendTenantGuid == self.tax.tenantGuid) {
          tenantName = item.sendTenantName
        }
      })
      console.log(imgList);
      var req = {
        guid: self.tax.guid,
        tenantGuid: self.tax.tenantGuid,
        tenantName,
        accountMonth: this.tax.accountMonth,
        staffGuid: this.tax.staffGuid,
        staffName: this.tax.staffName,
        organisationGuid: this.tax.organisationGuid,
        organisationName: this.tax.organisationName,
        mobileNo: this.tax.mobileNo,
        paymentTime: this.tax.paymentTime,
        paymentAttach: imgList,
      };
      self.fullscreenLoading = true;
      self.api.put(`/${serverConfig.msCustomerService}/paymentCertificate/update`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.page.pageIndex = 1;
          self.getList(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    handleExceed(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handlePdfRemove(file) {
      let self = this;
      self.filePdfAttachList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachList.splice(ind, 1);
        }
      });
    },
    uploadPdf(file) {
      let self = this;
      // console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachList.push(item);
            console.log(self.filePdfAttachList);
            self.$message.success('上传成功');
          } else {
            self.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleImgRemove(file) {
      let self = this;
      self.filePdfAttachListIII.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachListIII.splice(ind, 1);
        }
      });
    },
    handlePdfRemoveII(file) {
      let self = this;
      self.filePdfAttachListII.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachListII.splice(ind, 1);
        }
      });
    },
    uploadImg(file) {
      let self = this;
      // console.log('sssssssssssssssssssssssssss',file.file.name);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachListIII.push(item);
            // self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadPdfII(file) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachListII.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
  },
};
</script> 
<style scoped>
/deep/ .el-upload-dragger{
  width: 400px;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.search-area-div {
  width: 70px;
}

.el-date-editor .el-range__icon {
  margin-left: 0px;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid #D9D9D9;
  padding: 20px;
  padding-bottom: 15px;
}

/deep/ .el-dialog__body {
  padding: 20px;
  padding-bottom: 0;

}
</style>